
import { 
  LayoutDashboard, 
  Users, 
  Building2, 
  Briefcase, 
  Mail, 
  Calendar,
  BarChart3,
  Settings,
  Bot,
  Zap,
  UserPlus,
  MessageSquare,
  Shield,
  GitBranch,
  Inbox,
  Search,
  Phone,
  Linkedin,
  LucideIcon
} from "lucide-react";

export type NavItemType = {
  type: 'link';
  href: string;
  label: string;
  icon: LucideIcon;
  systemAdminOnly?: boolean;
} | {
  type: 'separator';
};

// Main Menu Section
export const mainMenuItems: NavItemType[] = [
  {
    type: "link",
    label: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    type: "link",
    label: "Calendar",
    href: "/calendar",
    icon: Calendar,
  },
  {
    type: "link",
    label: "Inbox",
    href: "/inbox",
    icon: Inbox,
  },
];

// Candidate HQ Section
export const candidateHQItems: NavItemType[] = [
  {
    type: "link",
    label: "Candidates",
    href: "/candidates",
    icon: Users,
  },
  {
    type: "link",
    label: "Screening",
    href: "/screening",
    icon: Phone,
  },
  {
    type: "link",
    label: "Jobs", 
    href: "/jobs",
    icon: Briefcase,
  },
  {
    type: "link",
    label: "Pipeline",
    href: "/pipeline",
    icon: GitBranch,
  },
];

// Client HQ Section
export const clientHQItems: NavItemType[] = [
  {
    type: "link",
    label: "Clients",
    href: "/clients",
    icon: Building2,
  },
  {
    type: "link",
    label: "Client BizDev",
    href: "/client-bizdev",
    icon: Search,
  },
  {
    type: "link",
    label: "Leads",
    href: "/leads",
    icon: UserPlus,
  },
];

// AI HQ Section
export const aiHQItems: NavItemType[] = [
  {
    type: "link",
    label: "AI Hub",
    href: "/ai-hub",
    icon: Bot,
  },
  {
    type: "link",
    label: "Automation",
    href: "/automation",
    icon: Zap,
  },
];

// Ops HQ Section
export const opsHQItems: NavItemType[] = [
  {
    type: "link",
    label: "Marketing",
    href: "/marketing",
    icon: Linkedin,
  },
  {
    type: "link",
    label: "Analytics",
    href: "/analytics", 
    icon: BarChart3,
  },
  {
    type: "link",
    label: "Integrations",
    href: "/integrations",
    icon: MessageSquare,
  },
  {
    type: "link",
    label: "Settings",
    href: "/settings",
    icon: Settings,
  },
  {
    type: "link",
    label: "Beta Program",
    href: "/beta-program",
    icon: Shield,
    systemAdminOnly: true,
  },
];

// Main Menu Section
export const mainNavItemsStructure: NavItemType[] = [
  ...mainMenuItems,
  { type: "separator" },
  ...candidateHQItems,
  { type: "separator" },
  ...clientHQItems,
  { type: "separator" },
  ...aiHQItems,
  { type: "separator" },
  ...opsHQItems,
];

export const settingsNavItemsStructure: NavItemType[] = [];

// Legacy export for backward compatibility
export const navItems = [
  {
    title: "Overview",
    items: [
      {
        title: "Dashboard",
        href: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "Analytics",
        href: "/analytics", 
        icon: BarChart3,
      },
    ]
  },
  {
    title: "Core Features",
    items: [
      {
        title: "Candidates",
        href: "/candidates",
        icon: Users,
      },
      {
        title: "Jobs", 
        href: "/jobs",
        icon: Briefcase,
      },
      {
        title: "Clients",
        href: "/clients",
        icon: Building2,
      },
      {
        title: "Leads",
        href: "/leads",
        icon: UserPlus,
      },
    ]
  },
  {
    title: "Communication",
    items: [
      {
        title: "Messages",
        href: "/messages",
        icon: Mail,
      },
      {
        title: "Calendar",
        href: "/calendar",
        icon: Calendar,
      },
    ]
  },
  {
    title: "AI & Automation",
    items: [
      {
        title: "AI Hub",
        href: "/ai-hub",
        icon: Bot,
      },
      {
        title: "Automation",
        href: "/automation",
        icon: Zap,
      },
    ]
  },
  {
    title: "System",
    items: [
      {
        title: "Integrations",
        href: "/integrations",
        icon: MessageSquare,
      },
      {
        title: "Settings",
        href: "/settings",
        icon: Settings,
      },
      {
        title: "Beta Program",
        href: "/beta-program",
        icon: Shield,
      },
    ]
  }
];
